module.exports = __webpack_public_path__ + "img/face_tipsnew.fc47c696.gif";